export default "__VITE_ASSET__1b072472__"